/* Top-level Admin component: token sign-in OR dashboard. */
import { Loader2 } from "lucide-react";
import { useAdminAuth } from "@/components/Admin/hooks";
import SignIn from "@/components/Admin/SignIn";
import Dashboard from "@/components/Admin/Dashboard";

export default function Admin() {
    const { status, error, busy, login, logout } = useAdminAuth();

    if (status === "checking") {
        return (
            <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center">
                <Loader2 className="w-8 h-8 animate-spin text-[#1FA8FF]" />
            </div>
        );
    }

    if (status === "authed") {
        return <Dashboard onLogout={logout} />;
    }

    return <SignIn login={login} busy={busy} error={error} />;
}
